
import firebase from 'firebase'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'
 

// firebase init goes here
 
 
  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
   
  const firebaseConfig = {
  apiKey: "AIzaSyAlyqC0bkEgPa1G-ercbg_gHzxmwpAj39w",
  authDomain: "staging-wlshop.firebaseapp.com",
  projectId: "staging-wlshop",
  storageBucket: "staging-wlshop.appspot.com",
  messagingSenderId: "1087994304040",
  appId: "1:1087994304040:web:ccf7111da1720ec858471d"
};


  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
 
 

 firebase.analytics()
const db = firebase.firestore()
  
const auth = firebase.auth()
 const storage= firebase.storage()
 

export  {
   
    db,
    storage,
    auth,
    
}




// WEBPACK FOOTER //
// ./src/firebase/firebaseconfig.js